<template>
  <div class="ccs-layout">
    <div class="ccs-layout ccs-12 ccs-layout--no-pad">
      <ccs-input class="ccs-6" type="number" label="Величина квоты"
        v-model.number="quota.amount" placeholder="Введите величину" />
      <ccs-input class="ccs-6" type="text" label="Тег (Регион/ВУЗ/Компания)"
        v-model="quota.label" placeholder="Введите тег (8 символов)"
        :disabled="isEditing"/>
    </div>
    <div class="ccs-layout ccs-layout--no-pad">
      <div>
        <button class="ccs-button" @click="submit">
          Сохранить изменения
        </button>
      </div>
      <div>
        <button class="ccs-button ccs-button--light" @click="$emit('close')">
          Отмена
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

import Input from '@/components/forms/Input.vue';

export default {
  name: 'Quota',
  components: {
    'ccs-input': Input,
  },
  data() {
    return {
      quota: {
        id: '',
        label: '',
        amount: 0,
      },
    }
  },
  props: {
    data: {
      type: Object,
      default: () => {
        return undefined;
      },
    },
  },
  computed: {
    ...mapState('events', ['event']),
    ...mapState('packages', ['pkg']),
    isEditing() {
      return !!(this.$props.data && this.$props.data.id);
    },
  },
  methods: {
    ...mapActions('packages', ['createQuota', 'updateQuota']),
    async submit() {
      if (this.quota.id) {
        await this.editQuota();
      } else {
        await this.addQuota();
      }
    },
    async addQuota() {
      try {
        this.quota.package_id = Number(this.pkg.id);
        let quota = await this.createQuota(this.quota);
        this.$toasted.success('Квота добавлена!');
        this.$emit('submit', quota);
        this.$emit('close');
      } catch (err) {
        this.$toasted.error(err.message);
      }
    },
    async editQuota() {
      try {
        await this.updateQuota(this.quota);
        this.$toasted.success('Изменения сохранены');
        this.$emit('close');
      } catch (err) {
        this.$toasted.error(err.message);
      }
    },
  },
  mounted() {
    if (this.$props.data && this.$props.data.id) {
      this.quota = this.$props.data;
    }
  },
}
</script>

<style>

</style>